export function getQueryParameters(): Map<string, string> {
  const queryParameters = new Map<string, string>();
  const searchSplitted = location.search.substring(1).split('&');
  for (let index = 0; index < searchSplitted.length; index++) {
    const vars = searchSplitted[index].split('=');
    queryParameters.set(vars[0], vars[1]);
  }
  return queryParameters;
}
